import { render, staticRenderFns } from "./TemplatePackage.vue?vue&type=template&id=5f8ddbfa&scoped=true"
import script from "./TemplatePackage.vue?vue&type=script&lang=js"
export * from "./TemplatePackage.vue?vue&type=script&lang=js"
import style0 from "./TemplatePackage.vue?vue&type=style&index=0&id=5f8ddbfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ddbfa",
  null
  
)

export default component.exports